import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { FilteredBlocks } from '../../ui-kit/BaseFiltration/FilteredBlocks.js';
import { FiltrationForm } from '../../ui-kit/BaseFiltration/FiltrationForm.js';
import { useFiltrationForm } from '../../ui-kit/BaseFiltration/useFiltrationForm.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { CurrencyInput } from '../../ui-kit/CurrencyInput/CurrencyInput.js';
import { InputRange } from '../../ui-kit/InputRange/InputRange.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { unique } from '../../utils/unique.js';
import { isRateRow } from './isRateRow.js';
import { numberRange } from './numberRange.js';
const DEFAULT_MIN_SUM = 500;
const DEFAULT_MAX_SUM = 1000000000;
const initialFiltrationState = {
    sum: {
        min: 10000,
        max: DEFAULT_MAX_SUM,
    },
    period: 3,
};
export const DepositFiltration = UniBlock(({ className, filtrationSchema = {}, resetButton, sumInput, periodInput, ...rest }) => {
    const [, { blocksToRender, blocksWithProps }, { field, reset }] = useFiltrationForm(initialFiltrationState, {
        block: rest.block,
        page: rest.options?.page,
        normalize: (content) => ({ ...content, period: getPeriod(content) }),
    });
    const rateRows = blocksWithProps.map(([, _]) => _?.paramsSource?.rateRows);
    const months = getMonths(rateRows);
    return (_jsxs(BlockWrapper, { className: style('space-y-2xs', className), defaultPadding: "p-0", version: "transparent", ...rest, children: [_jsx(FiltrationForm, { filtrationSchema: filtrationSchema, resetButton: resetButton, field: field, reset: reset, children: _jsxs("div", { className: "@4xl:max-w-xs space-y-lg", children: [_jsx(CurrencyInput, { label: sumInput?.title, min: DEFAULT_MIN_SUM, max: DEFAULT_MAX_SUM, ...field('sum', {
                                parse: (min) => ({ min: Number(min), max: DEFAULT_MAX_SUM }),
                                format: ({ min }) => String(min),
                            }) }), _jsx(InputRange, { title: periodInput?.title, items: ['От 3 мес', 'До 5 лет'], list: months, ...field('period') })] }) }), _jsx(FilteredBlocks, { blocksToRender: blocksToRender, ...rest })] }));
}, {
    childrenTypes: ['ProductBlock'],
    childSchema: (content) => ({
        ...(content?.filtrationSchema || {}),
        paramsSource: {
            type: 'object',
            title: 'Адрес справочника',
        },
    }),
});
const getPeriod = (content) => unique((content?.paramsSource?.rateRows || [])
    .filter(isRateRow)
    .flatMap((_) => numberRange(_.minMonths, _.maxMonths)));
const getMonths = (rateRows) => unique(rateRows
    .flatMap((item) => item || [])
    .filter(isRateRow)
    .flatMap((_) => numberRange(_.minMonths, _.maxMonths))).sort((a, b) => a - b) || [];
//# sourceMappingURL=DepositFiltration.js.map